import React from "react";
import { Col, Row } from "react-bootstrap";
import CarouselContents from "./components/CarouselItems";

const RowTwo = () => {

  return (
    <>
        <Row
          className="my-5 mx-auto"
        >
          <Col
            xs={12}
            md={12}
            lg={10}
            className="mx-auto">
            <CarouselContents />
          </Col>
        </Row>
    </>
  );
};

export default RowTwo;
